import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@theneatcompany/nui'
import Image from 'next/image'

import { Column, Columns } from '@/components/layout'
import { Link } from '@/components/common'
import facebookImg from '@/assets/blog/social/facebook.png'
import twitterImg from '@/assets/blog/social/twitter.png'
import linkedinImg from '@/assets/blog/social/linkedin.png'
import redditImg from '@/assets/blog/social/reddit.png'
import whatsappImg from '@/assets/blog/social/whatsapp.png'
import tumblrImg from '@/assets/blog/social/tumblr.png'
import pinterestImg from '@/assets/blog/social/pinterest.png'
import emailImg from '@/assets/blog/social/email.png'

import styles from './BlogShare.module.scss'

const IconLink = ({ to, name, src }) => (
  <Tooltip content={name} placement="top">
    <Link className={styles.iconLink} target="_blank" to={to}>
      <Image
        alt={name}
        className={styles.icon}
        height={18}
        src={src}
        width={18}
      />
    </Link>
  </Tooltip>
)

IconLink.propTypes = {
  to: PropTypes.string,
  name: PropTypes.string,
  src: PropTypes.shape({}), // StaticImageData?
}

const BlogShare = ({ link, title, description, photo }) => (
  <Columns className={styles.wrapper}>
    <Column>
      <h4>Share This Article</h4>
    </Column>
    <Column className={styles.iconListHolder}>
      <div className={styles.iconList}>
        <IconLink
          name="Facebook"
          src={facebookImg}
          to={`https://www.facebook.com/sharer.php?u=${link}`}
        />
        <IconLink
          name="Twitter"
          src={twitterImg}
          to={`https://twitter.com/share?text=${title}&url=${link}`}
        />
        <IconLink
          name="LinkedIn"
          src={linkedinImg}
          to={`https://www.linkedin.com/shareArticle?mini=true&url=${link}&title=${title}`}
        />
        <IconLink
          name="Reddit"
          src={redditImg}
          to={`https://reddit.com/submit?url=${link}&title=${title}`}
        />
        <IconLink
          name="WhatsApp"
          src={whatsappImg}
          to={`https://api.whatsapp.com/send?text=${link}`}
        />
        <IconLink
          name="Tumblr"
          src={tumblrImg}
          to={`https://www.tumblr.com/share/link?url=${link}&name=${title}&description=${encodeURIComponent(description)}`}
        />
        <IconLink
          name="Pinterest"
          src={pinterestImg}
          to={`https://pinterest.com/pin/create/button/?url=${link}&description=${encodeURIComponent(description)}&media=${photo}`}
        />
        <IconLink
          name="Email"
          src={emailImg}
          to={`mailto:?subject=${title}&body=${link}`}
        />
      </div>
    </Column>
  </Columns>
)

BlogShare.propTypes = {
  link: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  photo: PropTypes.string,
}

export default BlogShare
